// extracted by mini-css-extract-plugin
export default {"Arrow":"CarouselArrow_Arrow__IyEjA","ArrowRight":"CarouselArrow_ArrowRight__lx+l7"};